import React, { PropsWithChildren } from 'react';

import styles from './styles.module.scss';

export type SlidesProps = {
  categoryLabel?: string;
  subtitle?: string;
  title?: string;
};

const Slides = ({
  categoryLabel,
  children,
  subtitle,
  title
}: PropsWithChildren<SlidesProps>) => {
  return (
    <div className={styles.slides}>
      <div className={styles.category}>{categoryLabel}</div>
      <div className={styles.slideTitleSmall}>{title}</div>
      <div className={styles.slideText}>{subtitle}</div>
      <div className={styles.slideContainer}>{children}</div>
    </div>
  );
};

export default Slides;
